import { OverlayTrigger, Popover } from "react-bootstrap";
import { useResolvedDark } from "../../ThemeProvider/ThemeContext";

const DashboardInfoButton = ({
  dashboardName = "Dashboard",
  description,
  isDark: isDarkProp,
  // When set, the class owns the trigger's look (desktop desk chrome).
  className,
}) => {
  const isDark = useResolvedDark(isDarkProp);
  const text = typeof description === "string" ? description.trim() : "";

  if (!text) {
    return null;
  }

  const title = `About ${dashboardName}`;
  const theme = isDark
    ? {
        border: "#2A3560",
        muted: "#A6B0CF",
        surface: "#12172A",
        text: "#E8ECF8",
      }
    : {
        border: "#DDE5EF",
        muted: "#5B6472",
        surface: "#FFFFFF",
        text: "#0B1220",
      };

  const popover = (
    <Popover
      id="dashboard-info-popover"
      style={{
        maxWidth: "360px",
        background: theme.surface,
        borderColor: theme.border,
      }}
    >
      <Popover.Header
        as="h3"
        style={{
          background: theme.surface,
          borderColor: theme.border,
          color: theme.text,
          fontSize: "0.9rem",
          fontWeight: 700,
        }}
      >
        {title}
      </Popover.Header>
      <Popover.Body style={{ color: theme.text, fontSize: "0.88rem", lineHeight: 1.5 }}>
        {text}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger placement="bottom" rootClose trigger="click" overlay={popover}>
      <button
        type="button"
        aria-label={title}
        title={title}
        className={
          className ||
          "d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-pill"
        }
        style={className ? undefined : {
          minWidth: "auto",
          height: "28px",
          padding: "0 0.7rem",
          border: `1px solid ${theme.border}`,
          background: theme.surface,
          color: theme.text,
          cursor: "pointer",
          fontSize: "0.78rem",
          fontWeight: 600,
          lineHeight: 1,
        }}
      >
        About
      </button>
    </OverlayTrigger>
  );
};

export default DashboardInfoButton;
